// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f4ca0648","952":"b4b2597a"}[chunkId] + ".chunk.js";
};